import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getTrainingsLocations(userId) {
  try {
    const url = `${constants.endpoints.TRAININGS}/locations/${userId}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch locations failed', error.message);
    throw error;
  }
}

export async function getTrainings(userId) {
  try {
    const url = `${constants.endpoints.TRAININGS}/${userId}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch trainings failed', error.message);
    throw error;
  }
}

export async function getTraining(id) {
  try {
    const url = `${constants.endpoints.TRAININGS}/training/${id}`;
    const training = await getInstance().get(url);
    return training;
  } catch (error) {
    console.error('Fetch training failed', error.message);
    throw error;
  }
}

export async function createTraining(data) {
  try {
    const response = await getInstance().post(constants.endpoints.TRAININGS, data);
    return response.data;
  } catch (error) {
    console.error('Create training failed', error.message);
    throw error;
  }
}

export async function updateTraining(data) {
  try {
    const url = `${constants.endpoints.TRAININGS}`;
    const response = await getInstance().patch(url, data);
    return response.data;
  } catch (error) {
    console.error('Update training failed', error.message);
    throw error;
  }
}

export async function deleteTraining(trainingId) {
  try {
    const url = `${constants.endpoints.TRAININGS}`;
    const response = await getInstance().delete(url, { params: { trainingId } });
    return response.data;
  } catch (error) {
    console.error('Delete training failed', error.message);
    throw error;
  }
}

export async function getUsersOnTraining(trainingId) {
  try {
    const url = `${constants.endpoints.RESERVATIONS_MANAGEMENT}/trainingId/${trainingId}`;
    const response = await getInstance().get(url);
    return response;
  } catch (error) {
    console.error('Fetch Users failed', error.message);
    throw error;
  }
}

export async function copyTrainingsInWeek(data) {
  try {
    const response = await getInstance().post(constants.endpoints.COPY_TRAININGS, data);
    return response.data;
  } catch (error) {
    console.error('Copy trainings to new week', error.message);
    throw error;
  }
}

export async function getUsers(id) {
  try {
    const url = `${constants.endpoints.USERS}/users/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch users failed', error.message);
    throw error;
  }
}

export async function getCustomTrainings(id) {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch custom trainings failed', error.message);
    throw error;
  }
}

export async function createPersonalTraining(data) {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/personalTraining`;
    const response = await getInstance().post(url, data);
    return response.data;
  } catch (error) {
    console.error('Create personal training failed', error.message);
    throw error;
  }
}

export async function getAllPersonalTrainings(userId) {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/personalTraining/${userId}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch all personal trainings failed', error.message);
    throw error;
  }
}

export async function deletePersonalTraining(trainingId) {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/personalTraining`;
    const response = await getInstance().delete(url, { params: { trainingId } });
    return response.data;
  } catch (error) {
    console.error('Delete personal trainings failed', error.message);
    throw error;
  }
}

export async function getPersonalTrainingCustomTrainingWorkouts(personalTrainingId) {
  try {
    const url = `${constants.endpoints.CUSTOM_TRAININGS}/personalTraining/workouts/${personalTrainingId}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch all personal trainings failed', error.message);
    throw error;
  }
}